import fullStory from 'js/lib/fullStoryUtils';
import user from 'js/lib/user';

import type { DegreesV1 } from 'bundles/degree-home/components/__generated__/DegreesV1';
import { isFullStoryEnabled } from 'bundles/degree-home/utils/experimentUtils';

/**
 * initializeFullStory - Initialize and configure FullStory
 * @param {DegreesV1} degreeMetadata
 * @param {string} degreeSlug
 */
export const initializeFullStory = (degreeMetadata: DegreesV1, degreeSlug: string) => {
  const { external_id: externalId, is_staff: isStaff, is_superuser: isSuperuser } = user.get();
  // Init FullStory
  if (isFullStoryEnabled()) {
    fullStory.init();
    fullStory.set({
      userId: externalId,
      isStaff,
      isSuperuser,
      id: degreeMetadata?.id,
      name: degreeMetadata?.name,
      slug: degreeSlug,
    });
  }
};

export const endFullStorySession = () => {
  if (isFullStoryEnabled()) {
    fullStory.endSession();
  }
};

export default initializeFullStory;
